import React from 'react';
import { t } from '@lingui/macro';
import { Button, Table3 } from '@economic/taco';
import EmptyStateInitializer from '~/app/shared/table3tools/components/EmptyStateInitializer';
import { CreateProductGroupDialog } from '~/app/forms/Inventory/CreateOrEditProductGroup';
import { useProductGroups } from '~/app/shared/hooks/masterdata/useProductGroups';
import { useDialog } from '~/app/shared/components/Dialog/hooks/useDialog';
import { ProductGroup } from '../../../types/internal-api';
import { ViewProps } from '../types';
import useCompanyGroupCountrySpecificVatRules from './utils/useCompanyGroupCountrySpecificVatRules';

interface Props extends ViewProps<ProductGroup> {
    showCreateOnTheFly?: boolean;
}

export default function ProductGroupsComboboxView({
    onCreated: handleCreated,
    onSelected: handleSelected,
    showCreateOnTheFly: showCreateOnTHeFly,
}: Props) {
    const productGroupsQuery = useProductGroups({ options: { useCache: false } });
    const [appendCountrySpecificVatRules] = useCompanyGroupCountrySpecificVatRules();

    const [showDialog] = useDialog(CreateProductGroupDialog);

    const handleCreateProductGroup = () => {
        showDialog({ onSubmitted: handleCreated, showSaveAndNew: false, initialData: appendCountrySpecificVatRules(undefined) });
    };

    const createButton = (
        <Button appearance="primary" onClick={handleCreateProductGroup}>
            {t`Create product group`}
        </Button>
    );

    const handleRowClick = (product: ProductGroup) => {
        handleSelected(product);
    };

    return (
        <>
            <h1>{t`Product groups`}</h1>
            <Table3<ProductGroup>
                id="product-groups-view-table"
                data={productGroupsQuery.data}
                preset="complex"
                onRowClick={handleRowClick}
                enableFiltering={false}
                emptyState={() => <EmptyStateInitializer hasInitialized={!productGroupsQuery?.loading} />}
                toolbarLeft={showCreateOnTHeFly ? createButton : undefined}
                enableSorting>
                <Table3.Column id="id" accessor="id" header={t`No.`} sort="asc" />
                <Table3.Column id="name" accessor="name" align="left" header={t`Name`} />
            </Table3>
        </>
    );
}
